import { render, staticRenderFns } from "./dr-menu.vue?vue&type=template&id=740cd36f&"
import script from "./dr-menu.vue?vue&type=script&lang=js&"
export * from "./dr-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports